import type { UIMessage } from "ai";
import type { AssistantClientFailureReason } from "./client-error";
import type { AssistantProgress } from "./progress";
import type { AssistantReply } from "./types";

export const ASSISTANT_PROTOCOL_HEADER = "X-Assistant-Protocol";
export const ASSISTANT_PROTOCOL_VERSION = "ui-message-v1";

export type AssistantFailure = {
  ok: false;
  reason: string;
  message?: string;
  checkoutUrl?: string;
  remaining?: number;
  connectionReason?: AssistantClientFailureReason;
  progress?: AssistantProgress;
  blockedBy?: "earlier_request";
};
export type SendResponse = {
  ok: true;
  requestId: string;
  reply: AssistantReply;
  remaining: number;
  charged: number;
} | AssistantFailure;

export type CancelResponse = {
  ok: true;
  requestId: string;
  state: "cancelled" | "completed";
  charged: number;
  remaining?: number;
} | AssistantFailure;

/** The browser receives public activity and the settled, validated result.
 * Raw model text, reasoning and tool arguments never enter this stream. */
export type AssistantUIMessage = UIMessage<unknown, {
  "assistant-progress": AssistantProgress;
  "assistant-result": SendResponse;
}>;
